import React from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import Divider from "../Components/Divider";
import { FaWifi, FaWhmcs, FaGlobe } from "react-icons/fa";
import {
  MdAttachEmail,
  MdTravelExplore,
  MdSecurity,
  MdComputer,
} from "react-icons/md";
import CurrencyConverter from '../Components/CurrencyConverter';
import { useGeoLocation } from '../utils/useGeoLocation';
import { BsDeviceSsdFill } from "react-icons/bs";
import EnhancedSEO from "../Components/EnhancedSEO";
import { 
  generateMetaTags, 
  pageConfigs, 
  generateServiceSchema,
  generateProductSchema,
  generateFAQSchema
} from "../utils/seoUtils";
function Reseller() {
  const { userLocation } = useGeoLocation();

  // Enhanced SEO configuration
  const resellerPageConfig = generateMetaTags(pageConfigs.resellerHosting);
  
  // Structured data for reseller hosting page
  const resellerStructuredData = [
    generateServiceSchema(
      "Reseller Web Hosting Services",
      "Affordable reseller web hosting in India with WHM/cPanel, white-label solutions, and complete business tools to start your hosting company."
    ),
    generateProductSchema(
      "Reseller Hosting Plan",
      "Professional reseller hosting with WHM/cPanel, unlimited accounts, and white-label branding",
      "399"
    ),
    generateFAQSchema([
      {
        question: "What is reseller hosting?",
        answer: "Reseller hosting allows you to start your own web hosting business by purchasing hosting resources in bulk and reselling them to your customers with your own branding."
      },
      {
        question: "Do I get WHM with reseller hosting?",
        answer: "Yes, all our reseller hosting plans include WHM (Web Host Manager) which allows you to create and manage multiple cPanel accounts for your customers."
      },
      {
        question: "Can I use my own branding with reseller hosting?",
        answer: "Absolutely! Our reseller hosting plans support white-label solutions, allowing you to use your own company branding, logos, and custom nameservers."
      }
    ])
  ];

  return (
    <>
      <EnhancedSEO 
        pageConfig={resellerPageConfig}
        structuredData={resellerStructuredData}
      />
      {/* ======= Hero Section =======  */}
      <section
        id="top"
        className="sharedtop bgsharedhostingimg"
        style={{ color: "black" }}
      >
        <div className="container">
          <div className="row align-items-center py-md-5s">
            <div className="col-lg-6 col-12 topseccont">
              <div className="container">
                <span className="sa-bluebg-subhead">
                  👋 Up to 30% off Reseller Hosting
                </span>
                <h1 className="sa-hero-h1">Affordable Reseller Web Hosting</h1>
                <p>Make Money with your own Web Hosting Business</p>
                <br />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Feature bullet point"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>Simple Linux Reseller Hosting Setup</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Feature bullet point"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>Effortless Management </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Feature bullet point"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>Migration Assistance</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Feature bullet point"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>ClubHosty Advantage</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Feature bullet point"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>400+ Softaculous Apps</span>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Feature bullet point"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>Unmatched Speed</span>
                </div>
                <br />
                {/* <ul className="topseclist">
									<li>
										<i className="fa fa-check-square-o" aria-hidden="true"></i>
										Simple Linux Reseller Hosting Setup
									</li>
									<li>
										<i className="fa fa-check-square-o" aria-hidden="true"></i>
										Effortless Management
									</li>
									<li>
										<i className="fa fa-check-square-o" aria-hidden="true"></i>
										Migration Assistance
									</li>
									<li>
										<i className="fa fa-check-square-o" aria-hidden="true"></i>
										ClubHosty Advantage
									</li>
									<li>
										<i className="fa fa-check-square-o" aria-hidden="true"></i>
										400+ Softaculous Apps
									</li>
									<li>
										<i className="fa fa-check-square-o" aria-hidden="true"></i>
										Unmatched Speed
									</li>
								</ul> */}
                <a href="#pricing" className="btn btn-primary">
                  View Plans
                </a>
                {userLocation && (
                  <div style={{
                    marginTop: '20px',
                    padding: '10px 15px',
                    backgroundColor: '#e1f4fd',
                    borderRadius: '8px',
                    fontSize: '14px',
                    color: '#333'
                  }}>
                    📍 Showing prices for {userLocation.city}, {userLocation.country}
                  </div>
                )}
                {/* <p className="topsecstrt">
									Starts at <span>Rs.499/mo</span>
								</p> */}
              </div>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img
                // src="../assets/img/reseller-1.png"
                src="https://res.cloudinary.com/clubhosty/image/upload/v1713782893/banner-cpanelid_vznctq.png"
                alt="imges"
                className="img-fluid bounce-img reseller-hero-img"
              />
            </div>
          </div>
        </div>
      </section>
      {/* End Hero  */}

      <main id="main">
        {/* ======= Pricing Section ======= */}
        <section id="pricing" className="pricing section-bg">
          <div className="container">
            <div className="section-title">
              <h2>Pricing</h2>
              <h3>
                Check our <span>Pricing</span>
              </h3>
              <p>
                Buy the best cheap unlimited reseller hosting that will keep you
                one step ahead of your competitors! Grab YouStable’s Best
                Affordable Reseller Web Hosting Services and start working on
                your dream project!
              </p>
            </div>

            <div className="row tabingcustome">
              <div className="col-12">
                <ul
                  className="nav nav-pills mb-3 justify-content-center"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active first-button"
                      id="pills-inr-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-inr"
                      type="button"
                      role="tab"
                      aria-controls="pills-inr"
                      aria-selected="true"
                    >
                      Monthly
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link last-button"
                      id="pills-usd-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-usd"
                      type="button"
                      role="tab"
                      aria-controls="pills-usd"
                      aria-selected="false"
                    >
                      Yearly
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-inr"
                role="tabpanel"
                aria-labelledby="pills-inr-tab"
              >
                <div className="row">
                  <div className="col-md-4" data-aos-delay="100">
                    <div className="box sharedbox">
                      <div className="pricing-head">
                        <p>CHRH-1</p>
                        <p className="subprichead">
                          The best plan to start your brand new Web Hosting
                          journey!
                        </p>
                        {/* <h4><sup>₹</sup>399<span> / month</span></h4> */}
                        <h4 
                          id="customeprice"
                          style={{
                            background: '#21bcc3',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}
                        >
                          <CurrencyConverter priceINR={599} />
                          <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                        </h4>
                        <div className="btn-wrap mt-3">
                          <Link
                            to="http://my.clubhosty.com/cart.php?a=add&pid=4&billingcycle=monthly"
                            className="btn-buy"
                          >
                            Buy Now
                          </Link>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <span>
                            <MdComputer />
                          </span>
                          50 Cpanel
                        </li>
                        <li>
                          <span>
                            <BsDeviceSsdFill />
                          </span>
                          100 GB Disk Space
                        </li>
                        <li>
                          <span>
                            <FaWifi />
                          </span>
                          Unlimited Bandwidth
                        </li>
                        <li>
                          <span>
                            <MdAttachEmail />
                          </span>
                          Unlimited Email Accounts
                        </li>
                        <li>
                          <span>
                            <MdSecurity />
                          </span>
                          Free SSL Certificate
                        </li>
                        <li>
                          <span>
                            <MdTravelExplore />
                          </span>
                          Free Migration
                        </li>
                        <li>
                          <span>
                            <FaWhmcs />
                          </span>
                          Free WHMCS
                        </li>
                        <li>
                          <span>
                            <FaGlobe />
                          </span>
                          Unlimited Domains Allowed
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    <div className="box sharedbox">
                      <div className="pricing-head">
                        <span className="advanced">Featured</span>
                        <p>CHRH-2</p>
                        <p className="subprichead">
                          The best plan to start your brand new Web Hosting
                          journey!
                        </p>
                        {/* <h4><sup>₹</sup>599<span> / month</span></h4> */}
                        <h4 
                          id="customepricetwo"
                          style={{
                            background: '#21bcc3',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}
                        >
                          <CurrencyConverter priceINR={799} />
                          <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                        </h4>
                        <div className="btn-wrap mt-3">
                          <Link
                            to="http://my.clubhosty.com/cart.php?a=add&pid=5&billingcycle=monthly"
                            className="btn-buy"
                          >
                            Buy Now
                          </Link>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <span>
                            <MdComputer />
                          </span>
                          100 Cpanel
                        </li>
                        <li>
                          <span>
                            <BsDeviceSsdFill />
                          </span>
                          200 GB Disk Space
                        </li>
                        <li>
                          <span>
                            <FaWifi />
                          </span>
                          Unlimited Bandwidth
                        </li>
                        <li>
                          <span>
                            <MdAttachEmail />
                          </span>
                          Unlimited Email Accounts
                        </li>
                        <li>
                          <span>
                            <MdSecurity />
                          </span>
                          Free SSL Certificate
                        </li>
                        <li>
                          <span>
                            <MdTravelExplore />
                          </span>
                          Free Migration
                        </li>
                        <li>
                          <span>
                            <FaWhmcs />
                          </span>
                          Free WHMCS
                        </li>
                        <li>
                          <span>
                            <FaGlobe />
                          </span>
                          Unlimited Domains Allowed
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    <div className="box sharedbox">
                      <div className="pricing-head">
                        <p>CHRH-3</p>
                        <p className="subprichead">
                          The best plan to start your brand new Web Hosting
                          journey!
                        </p>

                        {/* <h4><sup>₹</sup>1199<span> / month</span></h4>  */}
                        <h4 
                          id="customepricethree"
                          style={{
                            background: '#21bcc3',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}
                        >
                          <CurrencyConverter priceINR={1299} />
                          <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                        </h4>
                        <div className="btn-wrap mt-3">
                          <Link
                            to="http://my.clubhosty.com/cart.php?a=add&pid=6&billingcycle=monthly"
                            className="btn-buy"
                          >
                            Buy Now
                          </Link>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <span>
                            <MdComputer />
                          </span>
                          150 Cpanel
                        </li>
                        <li>
                          <span>
                            <BsDeviceSsdFill />
                          </span>
                          300 GB Disk Space
                        </li>
                        <li>
                          <span>
                            <FaWifi />
                          </span>
                          Unlimited Bandwidth
                        </li>
                        <li>
                          <span>
                            <MdAttachEmail />
                          </span>
                          Unlimited Email Accounts
                        </li>
                        <li>
                          <span>
                            <MdSecurity />
                          </span>
                          Free SSL Certificate
                        </li>
                        <li>
                          <span>
                            <MdTravelExplore />
                          </span>
                          Free Migration
                        </li>
                        <li>
                          <span>
                            <FaWhmcs />
                          </span>
                          Free WHMCS
                        </li>
                        <li>
                          <span>
                            <FaGlobe />
                          </span>
                          Unlimited Domains Allowed
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-usd"
                role="tabpanel"
                aria-labelledby="pills-usd-tab"
              >
                <div className="row">
                  <div className="col-md-4" data-aos-delay="100">
                    <div className="box sharedbox">
                      <div className="pricing-head">
                        <p>CHRH-1</p>
                        <p className="subprichead">
                          The best plan to start your brand new Web Hosting
                          journey!
                        </p>

                        {/* <h4><sup>USD</sup>399<span> / month</span></h4>
                     <h4 id="customepricefour"><sup>USD</sup>399<span> / month</span></h4>
										<select id="priceSelectfour" onchange="myFunctionfour()" className="form-select py-2 customeselectoptin">
												<option><script language="javascript" src="https://my.clubhosty.com/feeds/productsinfo.php?pid=4&get=price&billingcycle=monthly&currency=2"></script></option>
										</select> */}

                        <h4 
                          id="customeprice"
                          style={{
                            background: '#21bcc3',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}
                        >
                          <CurrencyConverter priceINR={7188} />
                          <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                        </h4>
                        <div className="btn-wrap mt-3">
                          <Link
                            to="http://my.clubhosty.com/cart.php?a=add&pid=4&billingcycle=annually"
                            className="btn-buy"
                          >
                            Buy Now
                          </Link>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <span>
                            <MdComputer />
                          </span>
                          50 Cpanel
                        </li>
                        <li>
                          <span>
                            <BsDeviceSsdFill />
                          </span>
                          100 GB Disk Space
                        </li>
                        <li>
                          <span>
                            <FaWifi />
                          </span>
                          Unlimited Bandwidth
                        </li>
                        <li>
                          <span>
                            <MdAttachEmail />
                          </span>
                          Unlimited Email Accounts
                        </li>
                        <li>
                          <span>
                            <MdSecurity />
                          </span>
                          Free SSL Certificate
                        </li>
                        <li>
                          <span>
                            <MdTravelExplore />
                          </span>
                          Free Migration
                        </li>
                        <li>
                          <span>
                            <FaWhmcs />
                          </span>
                          Free WHMCS
                        </li>
                        <li>
                          <span>
                            <FaGlobe />
                          </span>
                          Unlimited Domains Allowed
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    <div className="box sharedbox">
                      <div className="pricing-head">
                        <span className="advanced">Featured</span>
                        <p>CHRH-2</p>
                        <p className="subprichead">
                          The best plan to start your brand new Web Hosting
                          journey!
                        </p>

                        {/* <h4><sup>USD</sup>599<span> / month</span></h4> 
                    <h4 id="customepricefive"><sup>USD</sup>599<span> / month</span></h4> 
										<select id="priceSelectfive" onchange="myFunctionfive()" className="form-select py-2 customeselectoptin">
												<option><script language="javascript" src="https://my.clubhosty.com/feeds/productsinfo.php?pid=5&get=price&billingcycle=monthly&currency=2"></script></option>
										</select> */}

                        <h4 
                          id="customeprice"
                          style={{
                            background: '#21bcc3',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}
                        >
                          <CurrencyConverter priceINR={9588} />
                          <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                        </h4>
                        <div className="btn-wrap mt-3">
                          <Link
                            to="http://my.clubhosty.com/cart.php?a=add&pid=5&billingcycle=annually"
                            className="btn-buy"
                          >
                            Buy Now
                          </Link>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <span>
                            <MdComputer />
                          </span>
                          100 Cpanel
                        </li>
                        <li>
                          <span>
                            <BsDeviceSsdFill />
                          </span>
                          200 GB Disk Space
                        </li>
                        <li>
                          <span>
                            <FaWifi />
                          </span>
                          Unlimited Bandwidth
                        </li>
                        <li>
                          <span>
                            <MdAttachEmail />
                          </span>
                          Unlimited Email Accounts
                        </li>
                        <li>
                          <span>
                            <MdSecurity />
                          </span>
                          Free SSL Certificate
                        </li>
                        <li>
                          <span>
                            <MdTravelExplore />
                          </span>
                          Free Migration
                        </li>
                        <li>
                          <span>
                            <FaWhmcs />
                          </span>
                          Free WHMCS
                        </li>
                        <li>
                          <span>
                            <FaGlobe />
                          </span>
                          Unlimited Domains Allowed
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    <div className="box sharedbox">
                      <div className="pricing-head">
                        <p>CHRH-3</p>
                        <p className="subprichead">
                          The best plan to start your brand new Web Hosting
                          journey!
                        </p>

                        {/* <h4><sup>USD</sup>1199<span> / month</span></h4> 
                     <h4 id="customepricesix"><sup>USD</sup>1199<span> / month</span></h4> 
										<select id="priceSelectsix" onchange="myFunctionsix()" className="form-select py-2 customeselectoptin">
												<option><script language="javascript" src="https://my.clubhosty.com/feeds/productsinfo.php?pid=6&get=price&billingcycle=monthly&currency=2"></script></option>
										</select> */}

                        <h4 
                          id="customeprice"
                          style={{
                            background: '#21bcc3',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}
                        >
                          <CurrencyConverter priceINR={15588} />
                          <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                        </h4>
                        <div className="btn-wrap mt-3">
                          <Link
                            to="http://my.clubhosty.com/cart.php?a=add&pid=6&billingcycle=annually"
                            className="btn-buy"
                          >
                            Buy Now
                          </Link>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <span>
                            <MdComputer />
                          </span>
                          150 Cpanel
                        </li>
                        <li>
                          <span>
                            <BsDeviceSsdFill />
                          </span>
                          300 GB Disk Space
                        </li>
                        <li>
                          <span>
                            <FaWifi />
                          </span>
                          Unlimited Bandwidth
                        </li>
                        <li>
                          <span>
                            <MdAttachEmail />
                          </span>
                          Unlimited Email Accounts
                        </li>
                        <li>
                          <span>
                            <MdSecurity />
                          </span>
                          Free SSL Certificate
                        </li>
                        <li>
                          <span>
                            <MdTravelExplore />
                          </span>
                          Free Migration
                        </li>
                        <li>
                          <span>
                            <FaWhmcs />
                          </span>
                          Free WHMCS
                        </li>
                        <li>
                          <span>
                            <FaGlobe />
                          </span>
                          Unlimited Domains Allowed
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Pricing Section  */}
        {/* <ResellerComp /> */}
        {/* ======= Shared Benifits =======  */}
        <section className="hostbeni">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div>
                  <h2>More About Reseller Hosting</h2>
                  <p>
                    Our Reseller Plans lets you start your own Hosting Business
                    by selling our white labeled products. Manage your own
                    customers, earn money, and run your own hosting company the
                    way you want. We give you complete control over all aspects
                    of your business. But don’t worry you’re not in this alone,
                    you will always have the backing of our 24/7 Guru Support
                    Crew anytime you need help. So be a Boss, make cash, and
                    take your business to the next level with ClubHosty’s
                    Reseller Hosting! Give your customers the ClubHosty
                    difference. Our ClubHosty Reseller Plans are hosted on the
                    fastest cutting edge hardware in the industry. Your plan
                    will be set up on servers using AMD EPYC CPUs and NVMEe
                    drives, that translates to blazing fast speeds for you and
                    your customers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Shared Bentfits  */}

        {/* ======= Services Section =======  */}
        <section id="services" className="services">
          <div className="container">
            <div className="section-title">
              <h2>Services</h2>
              <br />
              <h3>
                Experience The <span>ClubHosty</span> Difference
              </h3>
            </div>

            <div className="row">
              <div className="col-md-3" data-aos-delay="100">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bxl-dribbble"></i>
                  </div>
                  <h4>
                    <Link to="">Easy Setup & Integration</Link>
                  </h4>
                  <p>
                    Easy integration with our HTTP API and FREE storefront –
                    SuperSite.
                  </p>
                </div>
              </div>

              <div className="col-md-3" data-aos-delay="200">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bx-file"></i>
                  </div>
                  <h4>
                    <Link to="">Industry Best Prices & Offers</Link>
                  </h4>
                  <p>
                    Highly competitive Pricing & Fantastic Promotions year round
                    to help you make profits.
                  </p>
                </div>
              </div>

              <div className="col-md-3" data-aos-delay="300">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bx-tachometer"></i>
                  </div>
                  <h4>
                    <Link to="">Multi-Channel 24/7 Support</Link>
                  </h4>
                  <p>
                    Award-winning Support via email, chat, tickets, calls &
                    social media.
                  </p>
                </div>
              </div>

              <div className="col-md-3" data-aos-delay="100">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bx-world"></i>
                  </div>
                  <h4>
                    <Link to="">Billing & Customer Automation</Link>
                  </h4>
                  <p>
                    Automated billing and support management panels that have
                    been proven.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Services Section  */}

        {/* ======= Featured Services Section =======  */}
        <section
          id="featured-services"
          className="featured-services section-bg"
          style={{ padding: "60px 0px" }}
        >
          <div className="container">
            <div className="section-title" style={{ textAlign: "center", marginBottom: "4px" }}>
              <h2>Why Choose ClubHosty?</h2>
              <p><strong>RESELLER HOSTING BUNDLED WITH EXCEPTIONAL FEATURES</strong></p>
              <p style={{ textAlign: 'center' }}>The low cost and feature rich best reseller hosting in India from ClubHosty gives a head-start to the working of your business.</p>
            </div>
            <div className="row g-4">
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713839043/unlimited-websites_z2gnzk.svg"
                      alt="Unlimited cPanel Accounts"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Unlimited cPanel Accounts</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    With every Linux reseller hosting plan, users get unlimited cPanel accounts. They can host multiple domains within these cPanel accounts. There is no restriction on the Sub-domain and Add-on domain that can be added under unlimited cPanel accounts.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713839109/white-label-reseller_hmzyol.svg"
                      alt="100% White Labeled"
                      style={{ width: "35px", height: "35px", filter: "hue-rotate(317deg) saturate(1.2)" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">100% White Labeled</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    We don't want to stand like a wall between you and your customers, that's why you get a 100% White labeled system with all reseller hosting packages. The complete white label system limits the visibility of your merchant company from your customers so that you can sell the products under your own brand name.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713839204/ssd-nvme-storage_clrbm1.svg"
                      alt="100% SSD NVMe Storage"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">100% SSD NVMe Storage</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    If your choice is supreme speed then SSD NVMe storage is all you need. Traditional HDD drives take you nowhere, whereas websites stored on SSD reseller hosting servers speed up the performance of your website.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713839279/web-host-manager_f6wgty.svg"
                      alt="Web Host Manager"
                      style={{ width: "35px", height: "35px", filter: "hue-rotate(317deg) saturate(1.2)" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Web Host Manager (WHM)</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    With cPanel's master management tool - WHM, you can control a few very popular and resource-consuming sites and also, a huge number of smaller sites. WHM also allows you to create and manage unlimited cPanel accounts with unlimited websites, emails, etc.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713839339/cpanel-control-panel_kpjlht.svg"
                      alt="cPanel Control Panel"
                      style={{ width: "35px", height: "35px", filter: "hue-rotate(317deg) saturate(1.2)" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">cPanel Control Panel</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Utilize the unlimited cPanel accounts to its fullest by giving its access to your clients, so that they can manage their emails, domains, and websites from a web-based interface. You get the liberty to monitor the usage of your disk space and bandwidth.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713839416/one-click-installer_uepjez.svg"
                      alt="One-Click Installer"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">One-Click Installer</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Softaculous one-click installer allows you to install 400 plus applications like WordPress, Joomla, Drupal, etc. in few clicks. You and your clients can install these applications in few seconds.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Featured Services Section  */}
        {/* ======= About Section =======  */}
        <section 
          id="about" 
          className="about section-bg"
          style={{ 
            backgroundColor: "#ffffff", 
            padding: "80px 0",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6" data-aos-delay="100">
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  position: "relative",
                  height: "100%"
                }}>
                  <img
                    src="/assets/img/reseller.png"
                    alt="Reseller Interface Management"
                    style={{ 
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "15px",
                      filter: "hue-rotate(317deg) saturate(1.2)"
                    }}
                  />
                </div>
              </div>
              
              <div className="col-lg-6" data-aos-delay="200">
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center"
                }}>
                  <h2 style={{ 
                    color: "#333", 
                    fontSize: "36px", 
                    fontWeight: "600", 
                    lineHeight: "1.2", 
                    marginBottom: "20px",
                    fontFamily: "'Poppins', sans-serif"
                  }}>
                    Awesome <span style={{ color: "#21bcc3" }}>Reseller interfaces</span> to build and manage your sites easily and migration support too
                  </h2>
                  
                  <p style={{ 
                    color: "#666", 
                    fontSize: "16px", 
                    lineHeight: "1.6", 
                    marginBottom: "30px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: "500"
                  }}>
                    We realise that changing your web hosting provider is an uphill task, we make it cost-effective when you are in the business of reselling hosting space. Our Hosting Migration experts are on stand-by and will ensure a smooth transition from your existing provider. You don't even need to wait until tenure completion, chat with us now, to discuss your web hosting migration requirements with our in-house experts.
                  </p>
                  
                  <button 
                    onClick={() => {
                      const pricingSection = document.getElementById('pricing');
                      if (pricingSection) {
                        pricingSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    style={{ 
                      background: "#21bcc3",
                      border: "none",
                      color: "#fff",
                      padding: "15px 30px",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "8px",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(33, 188, 195, 0.3)",
                      transition: "all 0.3s ease",
                      fontFamily: "'Poppins', sans-serif",
                      alignSelf: "flex-start"
                    }}>
                    Get Started
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <style jsx>{`
            .about button:hover {
              transform: translateY(-2px);
              background: #20bfc0;
              box-shadow: 0 6px 20px rgba(33, 188, 195, 0.4);
            }
          `}</style>
        </section>
        {/* End About Section  */}

        {/* ======= Featured Services Section =======  */}
        {/* <section id="featured-services" className="featured-services">
					<div className="container">
						<div className="section-title">
							<h2>Product FAQs</h2>
							<h3>Frequently asked questions</h3>
						</div>
						<div className="row">
							<div className="col-md-4">
								<div className="icon-box" data-aos-delay="100">
									<div className="icon">
										<i className="#"></i>
									</div>
									<h4 className="title">
										<Link to=""> Reseller Hosting ?</Link>
									</h4>
									<p className="description">
										A Reseller account is a special cPanel accounts that gives
										unique privileges to it's users. cpanel reseller account
										come with WHM panel where you can create multiple cpanel
										accounts.
									</p>
								</div>
							</div>

							<div className="col-md-4">
								<div className="icon-box" data-aos-delay="200">
									<div className="icon">
										<i className="#"></i>
									</div>
									<h4 className="title">
										<Link to=""> How much activation time it takes ?</Link>
									</h4>
									<p className="description">
										We are offering you instant activation of your hosting after
										confirmation of payment transaction.
									</p>
								</div>
							</div>

							<div className="col-md-4">
								<div className="icon-box" data-aos-delay="300">
									<div className="icon">
										<i className="#"></i>
									</div>
									<h4 className="title">
										<Link to="">Can I use a private name server?</Link>
									</h4>
									<p className="description">
										Yes, you can name the server privately. It will surely help
										you in the branding of your reseller hosting business.
									</p>
								</div>
							</div>
						</div>
					</div>
				</section> */}
        {/* End Featured Services Section  */}

        {/* FAQ Start */}
        <section id="about" className="about">
          <div className="section-title">
            <h2>Frequently Asked Questions</h2>
            {/* <p style={{ padding: "10px" }}>
						You ask, we answer! Here are the most asked questions for our Domain
						Registration service!
					</p> */}
            <Divider />
          </div>
          <div className="accordionContainer">
            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What is reseller hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Reseller hosting is a kind of white-labelled approach to
                    selling web hosting services. It lets anyone sell hosting
                    without having their own infrastructure or technical
                    know-how. Alternatively, ClubHosty offers all the resources,
                    infrastructure and support you need to start and
                    successfully run a profit-driven reseller hosting business.
                  </p>
                  <p>
                    With reseller hosting, you can customize the hosting
                    packages, set your own prices, and brand them with your
                    company name. Read our in-depth blog about reseller hosting.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How to get started with reseller hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    There isn't a big part! To get started with reseller
                    hosting, you must first understand the hosting market and
                    your target audience and define business goals. It would
                    help if you also determined your pricing, hosting package
                    and range of hosting services you want to offer your
                    clients.
                  </p>
                  <p>
                    Once you have this basic idea, you can sign-up for a
                    reseller hosting plan from ClubHosty that suits your needs
                    and budget. Once you have set up your own web hosting
                    business, you need to market it wisely to generate customers
                    and revenue growth.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    For whom is reseller hosting best?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Generally, reseller hosting is an excellent choice for
                    anyone. However, it's a well-suited option for freelancers
                    and agencies. Plus, for web development and designer
                    agencies who want to offer additional services to their
                    clients and earn a good profit. Further, the completely
                    white-labelled system gives you limitless branding
                    capabilities.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Does website speed matter in reselling hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Of course! A website's speed has a key impact on your
                    overall business success. ClubHosty gives your customers a
                    top chance for success with all the speed enhanced features
                    and high-performance servers. Make sure to host with
                    ClubHosty for a better and faster reseller hosting
                    experience.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What is WHM & WHMCS?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Even though the names sound similar, WHM and WHMCS are
                    different concepts. WHM is an administrative control tool
                    that lets you manage the backend of several cPanel accounts.
                    On the other hand, WHMCS is an all-in-one client management,
                    billing, invoices & support platform for reseller hosting
                    businesses.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How are shared and reseller hosting different?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Shared hosting is meant just for a single owner. However,
                    reseller hosting is about reselling hosting services. The
                    shared cheap web hosting plans are not available for
                    reselling. As a reseller, you can create and manage multiple
                    shared hosting accounts with the aim of selling to your
                    clients.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Does Linux reseller hosting come with any automated billing
                    solution?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes! You can purchase WHMCS as an add-on with our reseller
                    hosting packages. It's a one-stop solution to make your
                    reseller journey smooth. You can manage your clients,
                    billing, invoices and entire web hosting business. Add it to
                    your cart during the checkout.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What's the difference between reseller hosting and an
                    affiliate program?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Reseller hosting is a hosting service that lets you start
                    your own web hosting business and sell products under your
                    brand tag. Alternatively, affiliate program is, wherein you
                    refer new clients and in turn earn commissions. At
                    ClubHosty, we offer commissions up to ₹5000/m per referral.
                    You can check out more about our hosting affiliate program.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Can I change my reseller hosting plan later?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, you have the flexibility to do this anytime. You can
                    upgrade and downgrade your Linux reseller hosting whenever
                    you need. Simply get in touch with our billing team and
                    they'll take care of the upgrades for you.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Can I use custom nameservers?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Totally yes! You can use your own custom nameservers to help
                    you brand your reseller hosting business. Alternatively, you
                    can even use our anonymous name servers if you’re unable to
                    register your own. You can read more about the name servers
                    here:
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Do you offer technical assistance when required?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Of course! All ClubHosty's reseller hosting packages include
                    24/7 support. Our team is here to address your technical
                    concerns on priority. You also have access to our resource
                    hub, which includes helpful articles, guides and tutorials.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Will my clients know if it's my hosting company?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    No! Your visibility is completely restricted from the parent
                    hosting company, for ex: (ClubHosty). You can run your web
                    hosting business with your brand tag without clients knowing
                    your actual hosting provider. This way, we give you total
                    freedom to promote your business with your name written on
                    it. Read more about it here.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </section>
        {/* FAQ End */}
      </main>
      {/* End #main  */}
    </>
  );
}

export default Reseller;
